import React, { useState } from 'react';
import { useHistory } from 'react-router';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import { Requester } from 'stores/RequesterStore';
import { SuggestionsSelector } from 'components/Form/SuggestionsSelector';
import { WithAddon } from 'components/Form/WithAddon';
import { Message } from 'components/Message';
import { ActionIcon, CancelIcon, DownArrowIcon } from 'components/Icon';

export interface UserInput
{
  token?: string,
  requester?: RequesterSelection,
}

class RequesterSelection
{
  requester?: Requester;
}

interface Props
{
  userInput: UserInput,
  saveUserInput: (input: UserInput) => void,
}

export const CreateForm: React.FC<Props> = ({userInput, saveUserInput}: Props) =>
{
  const history = useHistory();
  const { uiStore, requesterStore, requesterTokenStore } = useStore();

  const [token, setToken] = useState<string>(userInput.token || '');

  const [selectedRequester] = useState<RequesterSelection>(userInput.requester || {});
  const [requesterInput, setRequesterInput] = useState(selectedRequester.requester?.name || '');
  const [requesterSuggestions, setRequesterSuggestions] = useState<Requester[]>([]);
  const [requesterSuggestionsLoading, setRequesterSuggestionsLoading] = useState(false);
  const [requesterSuggestionsVisible, setRequesterSuggestionsVisible] = useState(false);

  const requesterInputChangeHandler = async (newValue: string) =>
  {
    setRequesterInput(prev => newValue);
    setRequesterSuggestionsLoading(prev => true);
    const suggestions = await requesterStore.requestSuggestionsAsync(newValue);
    setRequesterSuggestionsLoading(prev => false);
    setRequesterSuggestions(prev => suggestions);
  }
  const requesterInputBlurHandler = async () =>
  {
    setRequesterSuggestionsVisible(prev => false);
    await requesterInputChangeHandler(selectedRequester.requester?.name || '');
  }
  const selectRequesterHandler = async (x?: Requester) =>
  {
    selectedRequester.requester = x;
    await requesterInputChangeHandler(x?.name || '');
  }

  const createRequesterTokenHandler = async () =>
  {
    saveUserInput({token: token, requester: selectedRequester});
    await requesterTokenStore.createAsync(selectedRequester.requester?.id || 0, token);
    if (!requesterTokenStore.requesterToken.isError)
    {
      const requesterTokenToken = requesterTokenStore.requesterToken.data?.token || '';
      history.push(paths.buildRequesterTokenViewPath(requesterTokenToken));
    }
  };
  const cancelHandler = () =>
  {
    requesterTokenStore.requesterToken.clearError();
    history.goBack();
  };
  return (
    <>
      <div className="fields">
        <label>
          {uiStore.labels.common.forms.requesterToken.token.label}:
          <input type="text" placeholder={uiStore.labels.common.forms.requesterToken.token.placeholder} value={token} onChange={e => setToken(e.target.value)} />
        </label>
        <label>
          {uiStore.labels.common.forms.requesterToken.requester.label}:
          <SuggestionsSelector isLoading={requesterSuggestionsLoading}
                            suggestionsVisible={requesterSuggestionsVisible}
                            noSuggestionsView={<Message>{uiStore.labels.common.forms.requesterToken.requester.suggestionsInstruction}</Message>}
                            suggestions={requesterSuggestions}
                            maxSuggestions={10}
                            suggestionKeySelector={x => `${x.id}`}
                            suggestionViewTemplate={x => x.name}
                            onSuggestionSelect={selectRequesterHandler} >
          <WithAddon rightAddon={selectedRequester.requester ? <ActionIcon action={async () => await selectRequesterHandler()}><CancelIcon /></ActionIcon> : <DownArrowIcon />}>
            <input type="text"
                  placeholder={uiStore.labels.common.forms.requesterToken.requester.placeholder}
                  value={requesterInput}
                  onChange={async e => await requesterInputChangeHandler(e.target.value)}
                  onFocus={() => setRequesterSuggestionsVisible(prev => true)}
                  onBlur={() => setTimeout(requesterInputBlurHandler, 500)} />
          </WithAddon>
        </SuggestionsSelector>
        </label>
      </div>

      <div className="actions">
        <button onClick={createRequesterTokenHandler}>{uiStore.labels.common.forms.create}</button>
        <button onClick={cancelHandler}>{uiStore.labels.common.forms.cancel}</button>
      </div>
    </>
  );
}